import { PageHeader } from "components/common";
import { PageWrapper } from "components/common/pageWrapper/PageWrapper";
import darkPlusIcon from "assets/images/darkPlus.svg";
import { useQuery, useToggle } from "hooks";
import { AddCarrierModal } from "./addCarrierModal/AddCarrierModal";
import { useCarriers } from "api/logistics/carriers/hooks";
import { Table } from "components/miloDesignSystem/molecules/table";
import { mainListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { Carrier, CarrierTab } from "api/logistics/carriers/models";
import { useCarriersListColumns } from "./hooks/useCarriersListColumns";
import { RouteComponentProps } from "react-router";
import { getSearch } from "./utils/getSearch";
import { RightPanel } from "./rightPanel/RightPanel";
import { getTabs } from "./utils/getTabs";
import { carriers } from "components/common/moduleNavigation/moduleConfig/logistics/routes/carriers";
import {
  DrawerHelpers,
  getTablePropsBasedOnDrawerHelpers,
} from "components/utils/drawerHelpers/DrawerHelpers";

export const CarriersList = ({ match }: RouteComponentProps<{ tab: CarrierTab }>) => {
  const { tab } = match.params;
  const { query, updateQuery } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query, tab });
  const { data, error, isLoading, isPreviousData, pagination } = useCarriers(search);
  const addCarrierModal = useToggle();
  const columns = useCarriersListColumns();

  return (
    <>
      <PageWrapper>
        <PageHeader
          searchInput={{
            label: "Szukaj wśród przewoźników",
            tags: [],
          }}
          createButton={{
            alt: "utwórz",
            img: darkPlusIcon,
            label: "Utwórz przewoźnika",
            onClick: addCarrierModal.open,
          }}
          tabs={{
            list: getTabs(),
            routesRoot: `logistics/${carriers.url}`,
            urlSpan: "list",
          }}
          viewLabel="LOGISTICS_CARRIERS"
        />
        <div className="d-flex flex-1 overflow-hidden justify-content-between">
          <DrawerHelpers name="logisticsCarriers">
            {drawerHelpers => (
              <>
                <Table<Carrier>
                  rows={data}
                  columns={columns}
                  onPaginationChange={paginationState => {
                    updateQuery({ ...query, page: paginationState.pageIndex });
                  }}
                  isLoading={isLoading || isPreviousData}
                  error={error}
                  pagination={pagination}
                  uiSchema={mainListUiSchema}
                  {...getTablePropsBasedOnDrawerHelpers(drawerHelpers)}
                />
                <RightPanel />
              </>
            )}
          </DrawerHelpers>
        </div>
      </PageWrapper>
      {addCarrierModal.isOpen && <AddCarrierModal close={addCarrierModal.close} />}
    </>
  );
};
